import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSkip"><Path d="M4 3.91309V20.0866L16.9131 11.9998L4 3.91309Z" fill="currentColor"/><Path d="M20 3.99984H18.5V19.9998H20V3.99984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSkip;
